<template>
  <div>
    <div>
      <LoaderTuin :is-loading="loader" />
    </div>
    <ToastAlert
      :is-active="toastAlert"
      :type="typeMsg"
      :message="msg"
      @close="closeToast"
    />
    <!-- Dropzone para múltiples archivos -->
    <div
      :class="[
        'border-2 border-dashed p-6 rounded-lg cursor-pointer',
        dragging ? 'border-gray-300 bg-gray-50' : 'border-gray-300 bg-gray-50',
      ]"
      class="flex flex-col items-center justify-center space-y-4 p-4"
      @dragover.prevent
      @dragenter.prevent="dragging = true"
      @dragleave="dragging = false"
      @drop.prevent="handleDrop"
      @click="triggerFileInput"
    >
      <div class="relative w-full flex justify-center items-center">
        <img
          id="logo_company"
          src="@/assets/imgs/upload_property.svg"
          alt="Logo de copañía"
          class="md:w-[44px] md:h-[44px] h-11 w-11"
        >
      </div>
      <p class="text-gray-500 text-center text-sm">
        <span class="font-semibold">Da click</span> o arrastra la imagen <br>
        SVG, PNG, JPG or GIF (MAX. 800x400px)
      </p>
      <input
        ref="fileInput"
        type="file"
        class="hidden"
        accept="image/*"
        multiple
        @change="handleFileSelect"
      >
    </div>

    <!-- Lista de previews de archivos cargados -->
    <div
      v-if="files.length > 0"
      class="mt-4"
    >
      <div class="hidden">
        <h3 class="text-lg font-semibold">
          Archivos cargados:
        </h3>
        <p>
          Estos son los archivos que has cargado desde tu dispositivo. Si todo
          está correcto, haz clic en el botón 'Guardar imágenes'. Una vez
          guardadas, podrás verlas en la ficha técnica.
        </p>
        <p>
          <strong>
            Recuerda colocar la mejor vista de tu inmueble en la posición número
            uno, ya que será la foto principal al compartir en Facebook y
            WhatsApp. Si ya tienes imágenes guardadas, asegúrate de no duplicar el
            orden con las existentes
          </strong>
        </p>
      </div>

      <div class="grid grid-cols-2 sm:grid-cols-4 gap-4 mt-4">
        <div
          v-for="(file, index) in files"
          :key="index"
          class="w-[155px] mx-auto bg-white shadow-md rounded-md overflow-hidden relative cursor-grab active:cursor-grabbing transition-transform hover:scale-105"
          draggable="true"
          :data-list="'files'"
          :data-index="index"
          @dragstart="onDragStartFiles($event, index)"
          @dragover.prevent="onDragOverFiles($event, index)"
          @dragenter.prevent
          @drop="onDropFiles($event, index)"
          @dragend="onDragEndFiles"
          @touchstart="onTouchStartFiles($event, index)"
          @touchmove="onTouchMoveFiles($event)"
          @touchend="onTouchEndFiles($event)"
          :class="{ 'opacity-50 scale-95': draggedIndexFiles === index, 'border-2 border-tuin-100': dragOverFiles === index }"
        >
          <!-- Botón de eliminar en esquina superior derecha -->
          <button
            @click="removeFile(index)"
            class="absolute top-2 right-2 w-5 h-5 rounded-full bg-tuin-100 flex items-center justify-center hover:bg-tuin_hover transition-colors z-8"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="w-2.5 h-2.5" viewBox="0 0 9 9" fill="none">
              <path d="M5.56906 4.76562L8.57654 1.75815C8.6308 1.70573 8.67409 1.64304 8.70387 1.57371C8.73365 1.50439 8.74932 1.42983 8.74998 1.35439C8.75063 1.27894 8.73626 1.20412 8.70769 1.13429C8.67912 1.06446 8.63693 1.00102 8.58358 0.947672C8.53023 0.894322 8.46679 0.852131 8.39696 0.823562C8.32713 0.794992 8.25231 0.780616 8.17686 0.781271C8.10142 0.781927 8.02686 0.797602 7.95754 0.82738C7.88821 0.857159 7.82552 0.900446 7.7731 0.954715L4.76562 3.96219L1.75815 0.954715C1.65098 0.851213 1.50746 0.793941 1.35848 0.795236C1.2095 0.79653 1.06698 0.856287 0.961636 0.961636C0.856287 1.06698 0.79653 1.2095 0.795236 1.35848C0.793941 1.50746 0.851213 1.65098 0.954715 1.75815L3.96219 4.76562L0.954715 7.7731C0.900446 7.82552 0.857159 7.88821 0.82738 7.95754C0.797602 8.02686 0.781927 8.10142 0.781271 8.17686C0.780616 8.25231 0.794992 8.32713 0.823562 8.39696C0.852131 8.46679 0.894322 8.53023 0.947672 8.58358C1.00102 8.63693 1.06446 8.67912 1.13429 8.70769C1.20412 8.73626 1.27894 8.75063 1.35439 8.74998C1.42983 8.74932 1.50439 8.73365 1.57371 8.70387C1.64304 8.67409 1.70573 8.6308 1.75815 8.57654L4.76562 5.56906L7.7731 8.57654C7.88027 8.68004 8.02379 8.73731 8.17277 8.73601C8.32175 8.73472 8.46427 8.67496 8.56961 8.56961C8.67496 8.46427 8.73472 8.32175 8.73601 8.17277C8.73731 8.02379 8.68004 7.88027 8.57654 7.7731L5.56906 4.76562Z" fill="white"/>
            </svg>
          </button>

          <!-- Indicador de orden (preview) -->
          <div class="absolute top-2 left-2 bg-tuin-100 text-white text-[10px] px-2 py-0.5 rounded-full font-bold z-8">
            {{ index + 1 }}
          </div>
          
          <img
            :src="file.base64"
            alt="Imagen"
            class="w-[155px] h-36 object-cover rounded-lg"
          >
        </div>
      </div>

      <button
        class="bg-tuin-100 hover:bg-tuin_hover transition-colors text-sm font-medium text-white px-5 py-2.5 rounded-lg mt-4"
        :disabled="files.some(f => f.isCompressing)"
        @click="saveFiles"
      >
        <span v-if="files.some(f => f.isCompressing)">
          Procesando imágenes...
        </span>
        <span v-else>
          Guardar imágenes
        </span>
      </button>
    </div>

    <!-- Lista de imagenes guardadas -->
    <div
      v-if="gallery.length > 0"
      class="mt-10"
    >
      <div class="hidden">
        <h3 class="text-lg font-semibold">
          Fotos de la propiedad
        </h3>
        <p>
          Aquí puedes ver las fotos que se muestran en la ficha de tu propiedad.
          Debajo de cada imagen está el campo 'Orden', que define su posición.
        </p>
        <p>
          <strong>
            Coloca la mejor vista de tu inmueble en la posición número uno, ya que
            será la foto principal al compartir en Facebook y WhatsApp.
          </strong>
        </p>
      </div>

      <div class="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 mt-4">
        <div
          v-for="(img, index) in gallery"
          :key="img.id || index"
          class="w-[155px] mx-auto bg-white shadow-md rounded-md overflow-hidden relative cursor-grab active:cursor-grabbing transition-transform hover:scale-105"
          draggable="true"
          :data-list="'gallery'"
          :data-index="index"
          @dragstart="onDragStartGallery($event, index)"
          @dragover.prevent="onDragOverGallery($event, index)"
          @dragenter.prevent
          @drop="onDropGallery($event, index)"
          @dragend="onDragEndGallery"
          @touchstart="onTouchStartGallery($event, index)"
          @touchmove="onTouchMoveGallery($event)"
          @touchend="onTouchEndGallery($event)"
          :class="{ 'opacity-50 scale-95': draggedIndexGallery === index, 'border-2 border-tuin-100': dragOverGallery === index }"
        >
          <button
            @click="deleteImage(img.id)"
            class="absolute top-2 right-2 w-5 h-5 rounded-full bg-tuin-100 flex items-center justify-center hover:bg-tuin_hover transition-colors z-8"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="w-2.5 h-2.5" viewBox="0 0 9 9" fill="none">
              <path d="M5.56906 4.76562L8.57654 1.75815C8.6308 1.70573 8.67409 1.64304 8.70387 1.57371C8.73365 1.50439 8.74932 1.42983 8.74998 1.35439C8.75063 1.27894 8.73626 1.20412 8.70769 1.13429C8.67912 1.06446 8.63693 1.00102 8.58358 0.947672C8.53023 0.894322 8.46679 0.852131 8.39696 0.823562C8.32713 0.794992 8.25231 0.780616 8.17686 0.781271C8.10142 0.781927 8.02686 0.797602 7.95754 0.82738C7.88821 0.857159 7.82552 0.900446 7.7731 0.954715L4.76562 3.96219L1.75815 0.954715C1.65098 0.851213 1.50746 0.793941 1.35848 0.795236C1.2095 0.79653 1.06698 0.856287 0.961636 0.961636C0.856287 1.06698 0.79653 1.2095 0.795236 1.35848C0.793941 1.50746 0.851213 1.65098 0.954715 1.75815L3.96219 4.76562L0.954715 7.7731C0.900446 7.82552 0.857159 7.88821 0.82738 7.95754C0.797602 8.02686 0.781927 8.10142 0.781271 8.17686C0.780616 8.25231 0.794992 8.32713 0.823562 8.39696C0.852131 8.46679 0.894322 8.53023 0.947672 8.58358C1.00102 8.63693 1.06446 8.67912 1.13429 8.70769C1.20412 8.73626 1.27894 8.75063 1.35439 8.74998C1.42983 8.74932 1.50439 8.73365 1.57371 8.70387C1.64304 8.67409 1.70573 8.6308 1.75815 8.57654L4.76562 5.56906L7.7731 8.57654C7.88027 8.68004 8.02379 8.73731 8.17277 8.73601C8.32175 8.73472 8.46427 8.67496 8.56961 8.56961C8.67496 8.46427 8.73472 8.32175 8.73601 8.17277C8.73731 8.02379 8.68004 7.88027 8.57654 7.7731L5.56906 4.76562Z" fill="white"/>
            </svg>
          </button>

          <!-- Indicador de orden (galería) -->
          <div class="absolute top-2 left-2 bg-tuin-100 text-white text-[10px] px-2 py-0.5 rounded-full font-bold z-8">
            {{ img.order || index + 1 }}
          </div>

          <img
            :src="img.path_img"
            alt="Imagen"
            class="w-[155px] h-36 object-cover rounded-lg"
          >
          <!-- nombre opcional debajo si se requiere -->
        </div>
      </div>
    </div>
  </div>
</template>
  
<script setup>
import { ref, onMounted, computed, defineProps } from "vue";
import axios from "axios";

import LoaderTuin from "@/commond/LoaderTuin.vue";
import ToastAlert from "@/commond/ToastAlert.vue";
import { useStore } from "vuex";
import { usePropertySync } from "@/composables/usePropertySync";
const store = useStore();
let session = computed(() => store.getters.getUserSession);
const {
  syncWithPropiedades: syncWithPropiedadesShared,
  syncWithEasyBroker: syncWithEasyBrokerShared,
} = usePropertySync();

const fileInput = ref(null);
const dragging = ref(false);
const files = ref([]);
const gallery = ref([]);

// DnD state for previews (files)
const draggedIndexFiles = ref(null);
const dragOverFiles = ref(null);
// DnD state for gallery (saved)
const draggedIndexGallery = ref(null);
const dragOverGallery = ref(null);
// Touch state
const touchStart = ref({ x: 0, y: 0 });
const isTouchDragging = ref(false);

let toastAlert = ref(false);
let typeMsg = ref("");
let msg = ref("");
let loader = ref(false);

const props = defineProps({
  resp: {
    type: Object,
    required: true,
    default: () => ({ property_name: "" }),
  },
  propertyId: {
    type: Number,
    required: true,
    default: 0,
  },
});

// Definir los emits
const emit = defineEmits(['triggerUpdate']);

// CONFIGURACIÓN AGRESIVA PARA LÍMITES DE SERVIDOR ESTRICTOS
const COMPRESSION_CONFIG = {
  // Comprimir TODO por encima de 1MB para asegurar que cada imagen sea < 1MB
  maxFileSize: 1 * 1024 * 1024, // 1MB antes de comprimir
  
  // Configuraciones de compresión MUY agresivas
  compressionLevels: [
    {
      threshold: 10 * 1024 * 1024, // 10MB+ → Compresión extrema
      maxWidth: 1200,
      maxHeight: 900,
      quality: 0.5
    },
    {
      threshold: 5 * 1024 * 1024, // 5-10MB → Compresión fuerte
      maxWidth: 1400,
      maxHeight: 1050,
      quality: 0.6
    },
    {
      threshold: 3 * 1024 * 1024, // 3-5MB → Compresión moderada
      maxWidth: 1600,
      maxHeight: 1200,
      quality: 0.65
    },
    {
      threshold: 1 * 1024 * 1024, // 1-3MB → Compresión ligera
      maxWidth: 1920,
      maxHeight: 1440,
      quality: 0.75
    }
  ],
  
  // Configuración por defecto (para archivos ya pequeños)
  defaultMaxWidth: 2048,
  defaultMaxHeight: 1536,
  defaultQuality: 0.8,
  
  // META: Cada imagen final debe pesar menos de 800KB
  targetMaxSize: 800 * 1024 // 800KB por imagen
};

const handleDrop = (event) => {
  dragging.value = false;
  const droppedFiles = event.dataTransfer.files;
  handleFiles(droppedFiles);
};

const handleFileSelect = (event) => {
  const selectedFiles = event.target.files;
  handleFiles(selectedFiles);
};

const handleFiles = (fileList) => {
  //const maxFiles = 10;
  const validTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];
  
  //if (fileList.length > maxFiles) {
  //  showToast("warning", `Solo puedes subir máximo ${maxFiles} archivos a la vez`);
  //  return;
  //}
  
  for (let i = 0; i < fileList.length; i++) {
    const file = fileList[i];
    
    if (!validTypes.includes(file.type)) {
      showToast("danger", `${file.name} no es un tipo de imagen válido`);
      continue;
    }
    
    // Límite más alto para permitir imágenes de Android
    const maxFileSize = 50 * 1024 * 1024; // 50MB máximo absoluto
    if (file.size > maxFileSize) {
      showToast("danger", `${file.name} es demasiado grande (máximo 50MB)`);
      continue;
    }
    
    convertToBase64(file);
  }
};

const triggerFileInput = () => {
  fileInput.value.click();
};

// FUNCIÓN MEJORADA PARA CONVERSIÓN Y COMPRESIÓN AGRESIVA
const convertToBase64 = async (file) => {
  try {
    // Crear objeto file con metadatos
    const fileObj = {
      name: file.name,
      originalSize: file.size,
      compressedSize: file.size,
      order: files.value.length + 1,
      isCompressing: true, // Siempre comprimir inicialmente
      wasCompressed: false,
      base64: null
    };
    
    // Agregar inmediatamente para mostrar el preview
    files.value.push(fileObj);
    const fileIndex = files.value.length - 1;
    
    // COMPRIMIR TODAS las imágenes por encima de 1MB
    const needsCompression = file.size > COMPRESSION_CONFIG.maxFileSize;
    
    if (needsCompression) {
      // Mostrar mensaje informativo
      //showToast("success", `Optimizando ${file.name} para subida...`);
      
      // Comprimir la imagen
      let compressedBase64 = await compressImageAdvanced(file);
      
      // Verificar si el resultado sigue siendo muy grande
      let compressedSize = Math.round((compressedBase64.length * 3) / 4);
      
      // Si aún es muy grande, comprimir más agresivamente
      if (compressedSize > COMPRESSION_CONFIG.targetMaxSize) {
        console.log(`Primera compresión insuficiente (${formatFileSize(compressedSize)}), aplicando compresión extra...`);
        compressedBase64 = await compressImageExtra(file, compressedSize);
        compressedSize = Math.round((compressedBase64.length * 3) / 4);
      }
      
      files.value[fileIndex].base64 = compressedBase64;
      files.value[fileIndex].wasCompressed = true;
      files.value[fileIndex].isCompressing = false;
      files.value[fileIndex].compressedSize = compressedSize;
      
      console.log(`Imagen optimizada: ${file.name} - ${formatFileSize(file.size)} → ${formatFileSize(compressedSize)}`);
      
    } else {
      // Para archivos pequeños, convertir directamente pero verificar tamaño final
      const reader = new FileReader();
      reader.onload = () => {
        const base64 = reader.result;
        const base64Size = Math.round((base64.length * 3) / 4);
        
        files.value[fileIndex].base64 = base64;
        files.value[fileIndex].isCompressing = false;
        files.value[fileIndex].compressedSize = base64Size;
      };
      reader.readAsDataURL(file);
    }
    
  } catch (error) {
    console.error("Error al procesar imagen:", error);
    showToast("danger", `Error al procesar ${file.name}`);
    // Remover el archivo con error
    const errorIndex = files.value.findIndex(f => f.name === file.name && !f.base64);
    if (errorIndex !== -1) {
      files.value.splice(errorIndex, 1);
    }
  }
};

// FUNCIÓN DE COMPRESIÓN EXTRA PARA CASOS EXTREMOS
const compressImageExtra = (file) => {
  return new Promise((resolve, reject) => {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const img = new Image();
    
    img.onload = () => {
      try {
        // Configuración extra agresiva
        let maxWidth = 1024; // Muy pequeño
        let maxHeight = 768;
        let quality = 0.4; // Calidad muy baja
        
        // Si el archivo original era MUY grande, ser aún más agresivo
        if (file.size > 20 * 1024 * 1024) {
          maxWidth = 800;
          maxHeight = 600;
          quality = 0.3;
        }
        
        // Calcular dimensiones finales
        let { width, height } = img;
        const aspectRatio = width / height;
        
        if (width > height) {
          width = Math.min(width, maxWidth);
          height = width / aspectRatio;
        } else {
          height = Math.min(height, maxHeight);
          width = height * aspectRatio;
        }
        
        canvas.width = Math.round(width);
        canvas.height = Math.round(height);
        
        // Configurar para compresión máxima
        ctx.imageSmoothingEnabled = true;
        ctx.imageSmoothingQuality = 'medium'; // Reducir calidad de suavizado
        
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        
        const compressedBase64 = canvas.toDataURL('image/jpeg', quality);
        resolve(compressedBase64);
        
      } catch (error) {
        reject(error);
      }
    };
    
    img.onerror = () => reject(new Error('Error al cargar imagen para compresión extra'));
    
    const reader = new FileReader();
    reader.onload = (e) => {
      img.src = e.target.result;
    };
    reader.readAsDataURL(file);
  });
};

// FUNCIÓN DE COMPRESIÓN AVANZADA (MODIFICADA)
const compressImageAdvanced = (file) => {
  return new Promise((resolve, reject) => {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const img = new Image();
    
    img.onload = () => {
      try {
        // Determinar nivel de compresión según el tamaño
        let config = {
          maxWidth: COMPRESSION_CONFIG.defaultMaxWidth,
          maxHeight: COMPRESSION_CONFIG.defaultMaxHeight,
          quality: COMPRESSION_CONFIG.defaultQuality
        };
        
        for (let level of COMPRESSION_CONFIG.compressionLevels) {
          if (file.size >= level.threshold) {
            config = level;
            break;
          }
        }
        
        // Calcular nuevas dimensiones
        let { width, height } = img;
        const aspectRatio = width / height;
        
        if (width > config.maxWidth || height > config.maxHeight) {
          if (aspectRatio > 1) {
            // Landscape
            width = Math.min(width, config.maxWidth);
            height = width / aspectRatio;
            
            if (height > config.maxHeight) {
              height = config.maxHeight;
              width = height * aspectRatio;
            }
          } else {
            // Portrait
            height = Math.min(height, config.maxHeight);
            width = height * aspectRatio;
            
            if (width > config.maxWidth) {
              width = config.maxWidth;
              height = width / aspectRatio;
            }
          }
        }
        
        canvas.width = Math.round(width);
        canvas.height = Math.round(height);
        
        // Configurar contexto
        ctx.imageSmoothingEnabled = true;
        ctx.imageSmoothingQuality = 'high';
        
        // Dibujar imagen redimensionada
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        
        // Convertir a base64
        const compressedBase64 = canvas.toDataURL('image/jpeg', config.quality);
        resolve(compressedBase64);
        
      } catch (error) {
        reject(error);
      }
    };
    
    img.onerror = () => reject(new Error('Error al cargar imagen'));
    
    const reader = new FileReader();
    reader.onload = (e) => {
      img.src = e.target.result;
    };
    reader.onerror = () => reject(new Error('Error al leer archivo'));
    reader.readAsDataURL(file);
  });
};

// FUNCIÓN PARA REMOVER ARCHIVOS (ARREGLADA)
const removeFile = (index) => {
  files.value.splice(index, 1);
  
  // Reordenar automáticamente
  files.value.forEach((file, newIndex) => {
    file.order = newIndex + 1;
  });
  
  showToast("success", "Archivo eliminado");
};

// ========== Drag & Drop + Touch reordenamiento ==========
// Utilidad para mover elementos en un arreglo
function reorderList(list, fromIndex, toIndex) {
  if (fromIndex === toIndex || fromIndex == null || toIndex == null) return;
  const item = list.splice(fromIndex, 1)[0];
  list.splice(toIndex, 0, item);
}

// Reasignar órdenes secuenciales 1..n
function resequenceOrders(list, orderProp = 'order') {
  list.forEach((item, idx) => {
    item[orderProp] = idx + 1;
  });
}

// ---------- Preview files (local) ----------
function onDragStartFiles(e, index) {
  draggedIndexFiles.value = index;
  e.dataTransfer?.setData('text/plain', String(index));
  e.dataTransfer?.setDragImage?.(e.target, 10, 10);
}

function onDragOverFiles(e, index) {
  dragOverFiles.value = index;
}

function onDropFiles(e, index) {
  const from = draggedIndexFiles.value;
  const to = index;
  if (from == null || to == null) return onDragEndFiles();

  reorderList(files.value, from, to);
  resequenceOrders(files.value, 'order');
  showToast('success', 'Orden actualizado');
  onDragEndFiles();
}

function onDragEndFiles() {
  draggedIndexFiles.value = null;
  dragOverFiles.value = null;
}

// Touch (preview files)
function onTouchStartFiles(e, index) {
  const t = e.touches?.[0];
  if (!t) return;
  touchStart.value = { x: t.clientX, y: t.clientY };
  isTouchDragging.value = true;
  draggedIndexFiles.value = index;
}

function onTouchMoveFiles(e) {
  if (!isTouchDragging.value) return;
  const t = e.touches?.[0];
  if (!t) return;
  const el = document.elementFromPoint(t.clientX, t.clientY);
  const card = el?.closest?.('[data-list="files"][data-index]');
  if (card) {
    const idx = Number(card.getAttribute('data-index'));
    if (!Number.isNaN(idx)) dragOverFiles.value = idx;
  }
}

function onTouchEndFiles() {
  if (draggedIndexFiles.value != null && dragOverFiles.value != null) {
    reorderList(files.value, draggedIndexFiles.value, dragOverFiles.value);
    resequenceOrders(files.value, 'order');
    showToast('success', 'Orden actualizado');
  }
  isTouchDragging.value = false;
  draggedIndexFiles.value = null;
  dragOverFiles.value = null;
}

// ---------- Galería (guardadas) ----------
async function persistGalleryOrderSequential() {
  if (!props.propertyId) return; // nada que persistir en modo sin propiedad
  const url = `${process.env.VUE_APP_API_BASE_URL}/broker/property/${props.propertyId}/update_order_img`;
  const options = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${session.value.token_api}`,
    },
  };

  try {
    for (const img of gallery.value) {
      // Evitar llamadas si no hay id
      if (!img.id) continue;
      const payload = { order: img.order, img_id: img.id };
      await axios.put(url, payload, options);
    }
    showToast('success', 'Orden de galería guardado');
    
    /* Emitir evento para actualizar el componente padre
    emit('triggerUpdate', props.propertyId);*/
    
  } catch (err) {
    console.error('Error al persistir orden:', err);
    showToast('danger', 'No se pudo guardar el nuevo orden');
  }
}

function onDragStartGallery(e, index) {
  draggedIndexGallery.value = index;
  e.dataTransfer?.setData('text/plain', String(index));
  e.dataTransfer?.setDragImage?.(e.target, 10, 10);
}

function onDragOverGallery(e, index) {
  dragOverGallery.value = index;
}

async function onDropGallery(e, index) {
  const from = draggedIndexGallery.value;
  const to = index;
  if (from == null || to == null) return onDragEndGallery();

  reorderList(gallery.value, from, to);
  resequenceOrders(gallery.value, 'order');
  await persistGalleryOrderSequential();
  onDragEndGallery();
}

function onDragEndGallery() {
  draggedIndexGallery.value = null;
  dragOverGallery.value = null;
}

function onTouchStartGallery(e, index) {
  const t = e.touches?.[0];
  if (!t) return;
  touchStart.value = { x: t.clientX, y: t.clientY };
  isTouchDragging.value = true;
  draggedIndexGallery.value = index;
}

async function onTouchMoveGallery(e) {
  if (!isTouchDragging.value) return;
  const t = e.touches?.[0];
  if (!t) return;
  const el = document.elementFromPoint(t.clientX, t.clientY);
  const card = el?.closest?.('[data-list="gallery"][data-index]');
  if (card) {
    const idx = Number(card.getAttribute('data-index'));
    if (!Number.isNaN(idx)) dragOverGallery.value = idx;
  }
}

async function onTouchEndGallery() {
  if (draggedIndexGallery.value != null && dragOverGallery.value != null) {
    reorderList(gallery.value, draggedIndexGallery.value, dragOverGallery.value);
    resequenceOrders(gallery.value, 'order');
    await persistGalleryOrderSequential();
  }
  isTouchDragging.value = false;
  draggedIndexGallery.value = null;
  dragOverGallery.value = null;
}

// FUNCIÓN PARA FORMATEAR TAMAÑO DE ARCHIVO
const formatFileSize = (bytes) => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};

const deleteImage = async (imageId) => {
  const url = `${process.env.VUE_APP_API_BASE_URL}/broker/property/${props.propertyId}/delete_images`;

  const options = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${session.value.token_api}`,
    },
  };

  const data = {
    image_id: imageId,
  };

  try {
    const response = await axios.post(url, data, options);

    if (response.status === 401) {
      console.log("Sesión expirada. Por favor, inicia sesión nuevamente.");
    }

    if (response.status === 200) {
      gallery.value = gallery.value.filter(img => img.id !== imageId);
      showToast("success", "Imagen eliminada correctamente");
      
      // Emitir evento para actualizar el componente padre
      emit('triggerUpdate', props.propertyId);
      
      loader.value = false;
    }
  } catch (error) {
    console.error("Error al eliminar la imagen:", error);
    showToast("danger", "Hubo un problema al eliminar la imagen");
  } finally {
    loader.value = false;
  }
};

// FUNCIÓN MEJORADA PARA GUARDAR CON LÍMITES ESTRICTOS
async function saveFiles() {
  if (files.value.length < 3) {
    showToast("warning", "Debes subir al menos 3 imágenes para poder guardar.");
    return;
  }

  // Verificar que todas las imágenes estén procesadas
  if (files.value.some(f => f.isCompressing || !f.base64)) {
    showToast("warning", "Espera a que terminen de procesarse todas las imágenes.");
    return;
  }

  // VERIFICAR TAMAÑOS ANTES DE ENVIAR
  const totalSize = files.value.reduce((sum, file) => sum + file.compressedSize, 0);
  const maxPayloadSize = 5 * 1024 * 1024; // 4.5MB para estar seguros
  
  console.log(`Tamaño total del payload: ${formatFileSize(totalSize)}`);
  
  if (totalSize > maxPayloadSize) {
    showToast("danger", `Las imágenes ocupan ${formatFileSize(totalSize)}. El límite es ${formatFileSize(maxPayloadSize)}. Elimina algunas imágenes.`);
    return;
  }

  // Verificar imágenes individuales
  const oversizedFiles = files.value.filter(f => f.compressedSize > 1 * 1024 * 1024); // 1MB por imagen
  if (oversizedFiles.length > 0) {
    showToast("danger", `${oversizedFiles.length} imágenes aún están muy grandes. Se recomprimirán.`);
    
    // Recomprimir archivos problemáticos
    for (let i = 0; i < files.value.length; i++) {
      if (files.value[i].compressedSize > 1 * 1024 * 1024) {
        files.value[i].isCompressing = true;
        
        // Buscar el archivo original en fileInput
        const originalFile = Array.from(fileInput.value?.files || [])
          .find(f => f.name === files.value[i].name);
        
        if (originalFile) {
          const recompressed = await compressImageExtra(originalFile, files.value[i].compressedSize);
          const newSize = Math.round((recompressed.length * 3) / 4);
          
          files.value[i].base64 = recompressed;
          files.value[i].compressedSize = newSize;
          files.value[i].isCompressing = false;
          files.value[i].wasCompressed = true;
          
          console.log(`Recompresión: ${files.value[i].name} → ${formatFileSize(newSize)}`);
        }
      }
    }
  }

  loader.value = true;
  
  try {
    let isUpdating = props.propertyId != 0;
    let url = `${process.env.VUE_APP_API_BASE_URL}/broker/property/${props.propertyId}/upload_images`;

    let options = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${session.value.token_api}`,
      },
      timeout: 120000, // 2 minutos
    };

    // ESTRATEGIA ULTRA-CONSERVADORA: Una imagen a la vez si el payload es grande
    const finalTotalSize = files.value.reduce((sum, file) => sum + file.compressedSize, 0);
    
    let batches = [];
    if (finalTotalSize > 3 * 1024 * 1024) { // Si > 3MB, ir de una en una
      batches = files.value.map(file => [file]);
      showToast("success", "Subiendo imágenes una por una debido al tamaño...");
    } else {
      // Enviar en lotes de máximo 2 imágenes
      for (let i = 0; i < files.value.length; i += 2) {
        batches.push(files.value.slice(i, i + 2));
      }
    }

    let allResponses = [];
    
    for (let [batchIndex, batch] of batches.entries()) {
      // Preparar datos para envío
      const batchData = batch.map(file => ({
        name: file.name,
        base64: file.base64,
        order: file.order
      }));
      
      const batchSize = batchData.reduce((sum, item) => {
        return sum + Math.round((item.base64.length * 3) / 4);
      }, 0);
      
      console.log(`Enviando lote ${batchIndex + 1}/${batches.length} (${formatFileSize(batchSize)})`);
      
      const response = await axios.post(url, batchData, options);
      
      if (response.status === 401) {
        console.log("Sesión expirada");
        return;
      }
      
      if (response.status === 200) {
        allResponses.push(response.data);
      }
      
      // Pequeña pausa entre lotes para no sobrecargar el servidor
      if (batchIndex < batches.length - 1) {
        await new Promise(resolve => setTimeout(resolve, 500));
      }
    }

    showToast("success", "Imágenes guardadas correctamente");
    await getGallery();
    files.value = [];

    // Emitir evento para actualizar el componente padre
    emit('triggerUpdate', props.propertyId);

    if (isUpdating) {
      await syncWithPropiedades(props.propertyId);
      await syncWithEasyBroker(props.propertyId);
    }

  } catch (error) {
    console.error("Error al guardar archivos:", error);
    
    if (error.code === 'ECONNABORTED') {
      showToast("danger", "Timeout: Intenta con menos imágenes a la vez.");
    } else if (error.response?.status === 413) {
      showToast("danger", "Payload demasiado grande. Intenta eliminar algunas imágenes.");
    } else if (error.response?.status === 422) {
      showToast("danger", "Error en el formato de datos. Verifica las imágenes.");
    } else {
      showToast("danger", "Error al guardar las imágenes. Verifica tu conexión.");
    }
  } finally {
    loader.value = false;
  }
}

async function syncWithPropiedades(propertyId) {
  return syncWithPropiedadesShared(propertyId);
}

async function syncWithEasyBroker(propertyId) {
  return syncWithEasyBrokerShared(propertyId, {
    endpoint: "editar",
    onSuccess: () => {
      showToast("success", "Propiedad sincronizada con EasyBroker");
      setTimeout(() => {
        window.location.reload();
      }, 1500);
    },
    onError: () => {
      showToast("danger", "Error al sincronizar con EasyBroker");
    },
  });
}

async function showToast(type, message) {
  toastAlert.value = true;
  typeMsg.value = type;
  msg.value = message;

  setTimeout(() => {
    closeToast();
  }, 3000);
}

async function closeToast() {
  toastAlert.value = false;
  typeMsg.value = "";
  msg.value = "";
}

onMounted(async () => {
  console.log("entro a esta baina propiedad", props.propertyId);
  loader.value = true;
  await getGallery();
});

async function getGallery() {
  let url = `${process.env.VUE_APP_API_BASE_URL}/broker/property/${props.propertyId}/gallery`;

  let options = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${session.value.token_api}`,
    },
  };

  try {
    const response = await axios.get(url, options);

    if (response.status == 401) {
      console.log("Hay que sacarlo de la sesion ");
    }

    if (response.status == 200) {
      //showToast("success", response.data.message);
      gallery.value = response.data.resp;
    }
    loader.value = false;
  } catch (error) {
    showToast("danger", "Hubo un problema al cargar las imágenes");
    console.error("Error fetching data:", error);
  }
}
/*
async function updateOrder(pos) {
  let field_order = gallery.value[pos].order;
  let field_id = gallery.value[pos].id;

  if (field_order != null || field_order != "" || field_order.length != 0) {
    let url = `${process.env.VUE_APP_API_BASE_URL}/broker/property/${props.propertyId}/update_order_img`;

    let options = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${session.value.token_api}`,
      },
    };

    let param_post = {
      order: field_order,
      img_id: field_id,
    };

    try {
      const response = await axios.put(url, param_post, options);

      if (response.status == 401) {
        console.log("Hay que sacarlo de la sesion ");
      }

      if (response.status == 200) {
        console.log(response);
      }
      loader.value = false;
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }
}*/

// Exponer las referencias de files y gallery para validación externa
defineExpose({
  files,
  gallery
});
</script>
    
<style scoped>
/* Estilos personalizados si los necesitas */
</style>